/**
 * Whether the editor holds anything Save would send — the edit bar's *dirty*
 * and the leave guard's question (ADR-0032 §5). Pure, so the rule is tested
 * without mounting the editor.
 *
 * Compared by value, in order: moving a stage is a change, and so is a stage
 * that was added and then emptied back to its defaults — it is still a new
 * stage the server has never seen.
 */

import type { StageDraft } from '../../lib/api/services'

export function sameStages(a: StageDraft[], b: StageDraft[]): boolean {
  return JSON.stringify(a) === JSON.stringify(b)
}

/** The validation line under the title — how many errors the last check (or
 *  the last refused save) found, and how many things are worth a look. */
export function validationSummary(
  validation: { ok: boolean; errors: unknown[]; warnings: unknown[] } | null,
): { tone: 'error' | 'warning'; text: string } | null {
  if (!validation) return null
  if (!validation.ok) {
    return { tone: 'error', text: `${validation.errors.length} to fix` }
  }
  if (validation.warnings.length > 0) {
    const n = validation.warnings.length
    return { tone: 'warning', text: `${n} thing${n === 1 ? '' : 's'} worth a look` }
  }
  return null
}
